export default __webpack_public_path__ + "static/media/lock.7b4b42a0.svg";